export default __webpack_public_path__ + "static/media/zoomimg.cf0b723e.png";